<ng-template #modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="d-flex flex-column flex-center mb-5">

        @if (!modalConfig.hideIcon) {
          <mat-icon [ngClass]="modalConfig.isPrimary ? 'text-primary' : 'text-danger'"
            [class.small-icon]="modalConfig.isIconSmall">
            {{ modalConfig.isInfoIcon ? 'info' : 'error_outline' }}
          </mat-icon>
        }

        @if (!modalConfig.hideTitle) {
          <h2 class="font-weight-bolder my-5"
            [ngClass]="modalConfig.isTitleAlignLeft ? 'text-start' : 'text-center'">
            {{modalConfig.modalTitle}}
          </h2>
        }

        <ng-content></ng-content>
      </div>
      <div [ngClass]="modalConfig.isActionsAlignRight ? 'text-end' : 'text-center'"
        [class.modal-footer]="modalConfig.isFooterAllowed">
        @if (modalConfig.hideDismissButton === undefined || !modalConfig.hideDismissButton()) {
          <button type="button" ngbAutofocus class="btn btn-secondary me-4" (click)="dismiss()"
            [disabled]="modalConfig.disableDismissButton !== undefined && modalConfig.disableDismissButton()">
            {{ modalConfig.dismissButtonLabel }}
          </button>
        }
        @if (modalConfig.hideCloseButton === undefined || !modalConfig.hideCloseButton()) {
          <button type="button" class="btn" (click)="close()"
            [ngClass]="modalConfig.isPrimary ? 'btn-primary' : 'btn-danger'"
            [disabled]="modalConfig.disableCloseButton !== undefined && modalConfig.disableCloseButton()">
            {{ modalConfig.closeButtonLabel }}
          </button>
        }
      </div>
    </div>
  </div>
</ng-template>